export enum BaseCallState {
    Started = 'started',
    Ended = 'ended',
    Error = 'error',
}
